export const environment = {
  production: true,
  apiUrl: 'https://staging.agiltech.io/billetera-middleware/api',
  useMock: false,
};
